class RetainedNamespace {
  constructor(namespace) {
    this._namespace = namespace
    this._currentRetentions = {}
  }

  getValue(key) {
    const rawValue = window.localStorage.getItem(`retainedState.${this._namespace}.${key}`)
    if (rawValue) {
      return JSON.parse(rawValue)
    }
  }

  getValues() {
    const ret = {}
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i)
      if (key.startsWith(`retainedState.${this._namespace}`)) {
        const prop = key.replace(`retainedState.${this._namespace}.`, "")
        ret[prop] = this.getValue(prop) 
      }
    }
    return ret
  }

  setValue(key, value) {
    if (!this.inRetention(key)) {
      window.localStorage.setItem(`retainedState.${this._namespace}.${key}`, JSON.stringify(value))
    }
  }

  retained(key, callback) {
    const value = this.getValue(key)
    if (typeof value !== "undefined") {
      this._currentRetentions[key] = true
      callback(value)
      setTimeout(() => this._currentRetentions[key] = false, 25)
    }
  }

  inRetention(key) {
    return this._currentRetentions[key] === true
  }
}

const retainedNamespaceHandler = {
  get(obj, prop) {
    if (prop in obj) {
      return obj[prop]
    }

    return obj.getValue(prop)
  },

  set(obj, prop, value) {
    obj.setValue(prop, value)
    return true
  }
}

window.retainedState = {
  _namespaces: {},
  getNamespace: function(key) {
    if (!this._namespaces[key]) {
      this._namespaces[key] = new Proxy(new RetainedNamespace(key), retainedNamespaceHandler)
    }

    return this._namespaces[key]
  }
}
